export const AUDIO_OPERATIONS = ['speech', 'music', 'sfx', 'transcription'];

const AUDIO_MODEL_OPERATION = {
  elevenmusic: 'music',
  acestep: 'music',
  'stable-audio-3-medium': 'music',
  'stable-audio-3-large': 'music',
  'eleven-sfx': 'sfx',
  whisper: 'transcription',
  scribe: 'transcription',
  'universal-2': 'transcription',
  'universal-3-pro': 'transcription',
};

export function numberOrNull(value) {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function classifyAudioModel(model) {
  const name = String(model?.name || model?.id || '').trim();
  if (AUDIO_MODEL_OPERATION[name]) return AUDIO_MODEL_OPERATION[name];
  const inputs = Array.isArray(model?.input_modalities) ? model.input_modalities : [];
  const outputs = Array.isArray(model?.output_modalities) ? model.output_modalities : [];
  if (inputs.includes('audio') && outputs.includes('text')) return 'transcription';
  return 'speech';
}

export function normalizeModel(model) {
  const pricing = Object.fromEntries(
    Object.entries(model?.pricing || {}).map(([key, value]) => [key, key === 'currency' ? value : numberOrNull(value)]),
  );
  return {
    ...model,
    name: String(model?.name || model?.id || '').trim(),
    title: String(model?.title || model?.name || model?.id || '').trim(),
    description: String(model?.description || '').trim(),
    input_modalities: Array.isArray(model?.input_modalities) ? model.input_modalities : [],
    output_modalities: Array.isArray(model?.output_modalities) ? model.output_modalities : [],
    voices: Array.isArray(model?.voices) ? model.voices : [],
    pricing,
    audioOperation: classifyAudioModel(model),
  };
}

export function normalizeModels(models) {
  return (Array.isArray(models) ? models : []).map(normalizeModel).filter((model) => model.name);
}

export function modelsForAudioOperation(models, operation) {
  return normalizeModels(models).filter((model) => model.audioOperation === operation);
}

export function supportsVideoCapability(model, capability) {
  return Array.isArray(model?.video_capabilities) && model.video_capabilities.includes(capability);
}

export function audioExtension(format, model) {
  if (String(model || '').startsWith('qwen-tts')) return 'wav';
  return ['mp3', 'opus', 'aac', 'flac', 'wav', 'pcm'].includes(format) ? format : 'mp3';
}
